import { Field, RichTextField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C20CTAContentCardsProps = RenderingProps<
  C20CTAContentCardsFields,
  C20CTAContentCardsParams
>;

export type C20CTAContentCardsFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
  CTA?: LinkField;
};

export type C20CTAContentCardsParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  NumberOfColumns?: string;
  BackgroundColor?: string;
  EnableDropshadow?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
